import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';

import { formatDate } from '@helpers/date';

import { UserTimezoneStyled, UserTimezoneTypographyStyled } from './styled';

export const UserTimezone: React.FC = () => {
  const [timeZone, setTimeZone] = useState<string | null>(null);

  useEffect(() => {
    const gmtZone = formatDate(new Date(), 'z').slice(3);
    setTimeZone(gmtZone);
  }, []);

  return (
    <UserTimezoneStyled>
      <UserTimezoneTypographyStyled variant={'subtitle2'}>
        GMT
      </UserTimezoneTypographyStyled>
      <Typography variant={'subtitle2'}>{timeZone}</Typography>
    </UserTimezoneStyled>
  );
};
